<div class="wrapper">
  <div class="emr-page-container">
    <div class="emr-page-title">Load the Container</div>

    @if (!loaded()) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
    } @else if (containerId() !== null) {
    <div id="contentsWrapper">

      <div>
        <div class="inputWrapper">
          <span class="p-float-label">
            <input pInputText type="text" id="medicationId" #medicationIdInput
              [ngClass]="{'ng-invalid ng-dirty': !isValidMedicationId()}" [formControl]="medicationId"
              autofocus>
            <label htmlfor="medicationId">Medication ID</label>
          </span>
          <button pButton [disabled]="medicationId.value == null || medicationId.value == ''"
            (click)="medicationId.setValue('')">Empty</button>
        </div>

        <div class="medicationName">
          Medication:
          <span [ngClass]="{'red': !isValidMedicationId()}">
            {{medicationString()}}
          </span>
        </div>

        <div class="inputWrapper">
          <span class="p-float-label">
            <p-inputNumber id="quantity" [formControl]="quantity" [min]="0" />
            <label htmlfor="quantity">Quantity</label>
          </span>
          <button pButton [disabled]="quantity.value == null" (click)="quantity.setValue(undefined)">
            Don't Specify
          </button>
        </div>
      </div>

      <div id="knightmedsDiagram">
        <app-knightmeds-diagram [highlightedContainerId]="highlightedContainerId()" />
      </div>
    </div>

    @if (anyContainersOpen) {
    <div class="containerOpen">
      Close the container to continue
      <button pButton class="p-button-secondary" (click)="closeContainer()">(Close)</button>
    </div>
    }

    <div id="finishedButtonContainer">
      <button pButton (click)="onFinished(containerId()!)"
        [disabled]="anyContainersOpen || !isValidMedicationId()">Finished</button>
    </div>
    }
  </div>
</div>